import { render, staticRenderFns } from "./StlViewer.vue?vue&type=template&id=e34dffc8"
import script from "./StlViewer.vue?vue&type=script&lang=js"
export * from "./StlViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports